export const PLATFORM = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    DESKTOP: 'DESKTOP',
};
